import { baseApiUrl } from "../env";
import axiosInstance from "../Axios/axios";

/**
 *  @description  Api Call Function For Reactquery hooks
 * @param apiType={ Post ,Get,Delete,Update}
 * @param url=/api/v1/LaserLayoutFilmProduction/GetAllOrderColors
 * @param requestBody=body{object } 
 * @param reactQuery reactQuery= query params =>{url?x={reactQuery}}
 * @param reactQuery queryparameters= query key =>{url?queryparameters={X}}
 
 *  */
const customApi = async ({
  apiType,
  url,
  requestBody,
  queryparameters,
  reactQuery,
}) => {
  const urlApi = `${baseApiUrl}${url}`;

  try {
    switch (apiType) {
      case "get":
        if (queryparameters) {
          const queryUrl = `${urlApi}?${queryparameters}=${reactQuery || ""}`;
          return await axiosInstance.get(queryUrl);
        } else {
          if (requestBody) {
            return await axiosInstance.get(urlApi, requestBody);
          } else {
            return await axiosInstance.get(urlApi);
          }
        }
        break;

      case "post":
        if (queryparameters) {
          const queryUrl = `${urlApi}?${queryparameters}=${reactQuery || ""}`;
          return await axiosInstance.post(queryUrl, requestBody);
        } else {
          return await axiosInstance.post(urlApi, requestBody);
        }
        break;

      case "put":
        return await axiosInstance.put(urlApi, requestBody);
        break;

      case "delete":
        const deleteUrl = `${urlApi}?${queryparameters}=${requestBody || ""}`;
        return await axiosInstance.delete(deleteUrl);
        break;

      default:
        throw new Error(`Unsupported API type: ${apiType}`);
    }
  } catch (error) {
    console.error("customApi Error:", error);
    throw error;
  }
};

export { customApi };

/**========================================================================
 *                         user:javadBoroji     date:1402/11/
 *
 *          { apiType:post/get/put/delete
 *             url:sample=>/api/v1/BankInfo/GetAllBankInfo
 *             (optional)requestBody:body
 *             (optional)queryparameters: sample => bankInfoId=?1234  =>bankInfoId string pass
 *              (optional) reactQuery
 *           }
 *
 *
 *========================================================================**/
